/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';
import type { Html } from './Html';
import { HtmlFromJSON, HtmlFromJSONTyped, HtmlToJSON } from './Html';

/**
 *
 * @export
 * @interface ArticleModel
 */
export interface ArticleModel {
    /**
     *
     * @type {string}
     * @memberof ArticleModel
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof ArticleModel
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof ArticleModel
     */
    content: string;
    /**
     *
     * @type {Html}
     * @memberof ArticleModel
     */
    html: string;
    /**
     *
     * @type {string}
     * @memberof ArticleModel
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof ArticleModel
     */
    author: string;
    /**
     *
     * @type {Date}
     * @memberof ArticleModel
     */
    publishOn: Date;
    /**
     *
     * @type {FileUrl}
     * @memberof ArticleModel
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the ArticleModel interface.
 */
export function instanceOfArticleModel(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('content' in value)) return false;
    if (!('html' in value)) return false;
    if (!('type' in value)) return false;
    if (!('author' in value)) return false;
    if (!('publishOn' in value)) return false;
    return true;
}

export function ArticleModelFromJSON(json: any): ArticleModel {
    return ArticleModelFromJSONTyped(json, false);
}

export function ArticleModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArticleModel {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        content: json['content'],
        html: json['html'],
        type: json['type'],
        author: json['author'],
        publishOn: new Date(json['publish_on']),
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function ArticleModelToJSON(value?: ArticleModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        content: value['content'],
        html: HtmlToJSON(value['html']),
        type: value['type'],
        author: value['author'],
        publish_on: value['publishOn'].toISOString(),
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
